import { CommunityThreadsConfig } from '@/types/community-threads'
import { httpClient } from './http-client'

export class __cCommunityThreads {
  static async getCommunityThreads() {
    try {
      const { data } = await httpClient.V4_NEW.get<CommunityThreadsConfig>(
        `/settings/community_threads`
      )
      return data
    } catch (error) {
      console.error('Failed to fetch community threads settings:', error)
      return null
    }
  }
}
